<template>
  <div class="big-map-box">
    <div class="map-title">{{ title }}</div>
    <div class="map-content" id="PointCloudmap"></div>
    <div class="map-darkcorner"></div>
<!--    <div @click="layer.setFitView()" class="set-fitview" v-if="fitviewBtnFlag">归位</div>-->
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'PointCloudmap',
  props: {
    title: {
      type: String,
      default: ''
    },
    // 控制角度和网格高度
    pitch: {
      type: Number,
      default: 45
    },
    opacity: {
      type: Number,
      default: 1
    },
    // 网格大小
    radius: {
      type: Number,
      default: 0.9,
      color: 'rgba(200, 50, 40, 1)',
    },
    colorList: {
      type: Array,
      default() {
        return ['#0080ff', '#00cdff', '#00d8ae', '#a1e058', '#ffe05f']
      }
    },
    gridData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      map: null,
      layer: null,
      fitviewBtnFlag: false
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.map = new AMap.Map('PointCloudmap', {
        mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          // zoom: 5,
          // center: [107.4976,32.1697]

      })
      setInterval(() => {
        this.map.on('mapmove', () => {
          this.fitviewBtnFlag = true
        })
      }, 1000)
      this.initLayer()
    },
    initLayer() {



      /*
         this.layer = new Loca.GridLayer({
        map: this.map
      })
      this.layer.setData(this.gridData, {
        lnglat: obj => {
          var val = obj.value
          return [val['lng'], val['lat']]
        }
      })

      this.layer.setOptions({
        unit: 'meter',
        mode: 'count',
        style: {
          color: this.colorList,
          radius: this.radius,
          opacity: this.opacity,
          gap: 150,
          height: [
            this.pitch ? this.pitch * 20 + 2000 : 0,
            this.pitch ? this.pitch * 50 + 5000 : 0
          ]
        }
      })*/
/*
       update by zy
*/

        this.layer = new Loca.ScatterPointLayer({
            map: this.map
        });
        // 传入原始数据

         this.layer.setData(this.gridData, {
            lnglat: 'lnglat'   // 指定坐标数据的来源，数据格式: 经度在前，维度在后，数组格式。
        });



        // 配置样式
        this.layer.setOptions({
            unit: 'px',
            style: {
                opacity:0.5,
                radius: 2,     // 圆形半径，单位像素
                color: '#1EB3DB', // 填充颜色
                borderWidth: 0.5,   // 边框宽度
                borderColor: '#1EB3DB'  // 边框颜色
            }
        });
      this.layer.render()
      this.layer.setFitView()
    }
  }
}
</script>

<style scoped lang="less">
</style>
